<template>
    <vxe-modal
        :title="formInput.title"
        v-model="formInput.isShow"
        width="880"
        height="550"
        resize
        show-zoom
    >
        <div class="detail-container">
            <div class="detail-left">
                <img :src="formInput.formData.appIcon" alt="" />
            </div>
            <div class="detail-right">
                <div class="__header">{{ formInput.formData.appName }}</div>
                <div class="__bottom">
                    <div>@{{ formInput.formData.createMan }}</div>
                    <div>
                        <svg
                            t="1756362374635"
                            class="icon"
                            viewBox="0 0 1092 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="17931"
                            width="10"
                            height="10"
                        >
                            <path
                                d="M324.539733 0v392.260267H68.266667l468.992 406.869333 486.536533-406.869333H785.066667V0H324.539733zM0 992.6656h1092.266667V887.466667H0v105.198933z"
                                fill="#99B4D6"
                                p-id="17932"
                            ></path>
                        </svg>

                        {{ formInput.formData.downloadTimes }}
                    </div>
                    <div>
                        <svg
                            t="1756362009717"
                            class="icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="7688"
                            width="10"
                            height="10"
                        >
                            <path
                                d="M928.445934 408.299453H664.597495C766.889116 29.804198 594.187335 10.458564 594.187335 10.458564c-73.155759 0-58.000776 58.036902-63.510037 67.736814 0 185.07504-196.183877 330.104075-196.183878 330.104075v524.860963c0 51.805116 70.46435 70.446287 98.100971 70.446287h396.431963c37.336532 0 67.700688-98.064844 67.700688-98.064844 98.064844-334.312789 98.064844-433.714306 98.064844-433.714306-0.018063-69.055424-66.345952-63.5281-66.345952-63.5281zM226.204833 408.462022H68.260646c-32.62205 0-33.163944 32.044029-33.163945 32.044028l32.603987 529.467067c0 33.633586 33.633586 33.633586 33.633586 33.633586h136.792239c28.503651 0 28.232704-22.271865 28.232704-22.271864V448.562216c0-40.660152-40.154383-40.100194-40.154384-40.100194z"
                                fill="#FFA800"
                                p-id="7689"
                            ></path>
                        </svg>
                        {{ formInput.formData.likeTimes }}
                    </div>
                    <div>
                        <svg
                            t="1756362943296"
                            class="icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="19962"
                            width="10"
                            height="10"
                        >
                            <path
                                d="M512.092526 889.548815l-250.07132 127.559047a62.170407 62.170407 0 0 1-82.723213-24.941305 57.781908 57.781908 0 0 1-6.143899-37.667952l47.761501-270.258418L18.605776 492.901617A58.513324 58.513324 0 0 1 17.508651 408.861854a61.950982 61.950982 0 0 1 35.034853-17.334572l279.620549-39.423352 125.072231-245.829105a62.097266 62.097266 0 0 1 81.991796-26.98927 60.341866 60.341866 0 0 1 27.793829 26.98927l125.072231 245.829105 279.620549 39.423352a59.756733 59.756733 0 0 1 51.784292 67.363465 58.513324 58.513324 0 0 1-17.846564 34.01087l-202.309819 191.411712 47.761501 270.258417a59.610449 59.610449 0 0 1-49.95575 68.606873 62.828682 62.828682 0 0 1-38.83822-5.997616z"
                                fill="#FFCA28"
                                p-id="19963"
                            ></path></svg
                        >收藏
                    </div>
                    <div>
                        <svg
                            t="1756363354746"
                            class="icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="31030"
                            width="10"
                            height="10"
                        >
                            <path
                                d="M11.906977 686.144703C11.906977 815.040274 116.401033 919.527686 245.282364 919.527686 336.61059 919.527686 415.644553 867.07512 453.998997 790.654166L678.775475 830.246531 678.69434 836.171752C678.69434 928.249761 753.334677 1002.872594 845.396182 1002.872594 937.453687 1002.872594 1012.093023 928.249761 1012.093023 836.171752 1012.093023 744.092767 937.453687 669.475911 845.396182 669.475911 778.632502 669.475911 721.072771 708.661581 694.439626 765.323431L475.158671 726.724775C477.472673 713.56004 478.661727 699.982586 478.661727 686.144703 478.661727 625.213488 455.296238 569.751719 417.078034 528.208991L619.848371 325.417817C638.146084 332.321744 657.974439 336.079229 678.69434 336.079229 770.756846 336.079229 845.396182 261.456372 845.396182 169.383388 845.396182 77.310404 770.756846 2.686547 678.69434 2.686547 586.637836 2.686547 511.9985 77.310404 511.9985 169.383388 511.9985 216.140133 531.256868 258.382062 562.251562 288.660361L365.047879 485.862876C330.029199 464.866614 289.08725 452.76572 245.282364 452.76572 116.401033 452.771721 11.906977 557.249131 11.906977 686.144703L11.906977 686.144703 11.906977 686.144703Z"
                                fill="#7A7A7A"
                                p-id="31031"
                            ></path></svg
                        >分享
                    </div>
                </div>
                <div class="__content">
                    <a-tabs
                        v-model:activeKey="activeTab"
                        type="card"
                        :destroyInactiveTabPane="true"
                    >
                        <a-tab-pane key="comInfo" tab="基本信息">
                            <div>
                                <comInfo
                                    :appId="formInput.formData.Id"
                                    :key="formInput.formData.Id + '-infor'"
                                />
                            </div>
                        </a-tab-pane>
                        <a-tab-pane key="comVersion" tab="版本信息">
                            <div>
                                <comVersion
                                    :appId="formInput.formData.Id"
                                    :isShowUpload="false"
                                    :key="formInput.formData.Id + '-version'"
                                />
                            </div>
                        </a-tab-pane>
                        <a-tab-pane key="comServer" tab="服务信息">
                            <div>
                                <comServer
                                    :appId="formInput.formData.Id"
                                    :key="formInput.formData.Id + '-server'"
                                />
                            </div>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </div>
        </div>
    </vxe-modal>
</template>

<script setup>
import {
    ref,
    onMounted,
    getCurrentInstance,
    defineExpose,
    reactive,
} from "vue";
import comInfo from "./comInfo.vue";
import comVersion from "./comVersion.vue";
import comServer from "./comServer.vue";
import Qs from "qs";
import { VXETable } from "vxe-table";
import { useRoute } from "vue-router";
const { proxy } = getCurrentInstance();
const activeTab = ref("comServer"); // 默认显示 comServer
const route = useRoute();

const formInput = reactive({
    title: "应用详情",
    isShow: false,
    formData: {
        Id: "",
        status: "0",
        appName: "名称",
        appDesc: "",
        appIcon: "",
        mcpServeName: "",
        isRemote: "",
        creatorUID: "",
        CreateMan: "",
        creationTime: "",
        appClassId: "",
        labelId: "",
        fPathPackage: "",
    },
});
const showAPPDetail = (row) => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 20,
        searchKey: [row.Id],
    };
    proxy.$api.componentManageAPI
        .getComponentOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }

            formInput.formData = res.data.Data;
            if (formInput.formData.appIcon == "") {
                formInput.formData.appIcon = row.appIcon;
            }
            formInput.isShow = true;
        })
        .catch((error) => {
            console.log(error);
        });
};
onMounted(() => {
    const viewType = route.query.viewType;
    if (viewType) {
        switch (viewType) {
            case "1":
                activeTab.value = "comInfo";
                break;
            case "2":
                activeTab.value = "comVersion";
                break;
            case "3":
                activeTab.value = "comServer";
                break;
        }
    }
});
defineExpose({ showAPPDetail });
</script>
<style lang="scss" scoped>
.detail-container {
    display: flex;
    width: 100%;
    height: 100%; /* 如果要撑满父级高度 */
}

.detail-left {
    flex: 0 0 60px; /* 固定宽度，可以按需求调整，比如 100~150px */
    margin-right: 10px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    overflow: hidden;
    background-color: transparent;
    margin-top: 30px;

    img {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        object-fit: cover;
        cursor: pointer;
    }
}

.detail-right {
    flex: 1; /* 占满剩余空间 */
    display: flex;
    flex-direction: column;
    padding: 12px;
    min-width: 0; /* 防止内容撑爆 */
}

.detail-right .__header {
    flex: 0 0 auto; /* 上面部分，固定高度 */
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 2px;
}

.detail-right .__content {
    flex: 1; /* 下面部分，占满剩余 */
    overflow: auto;
    padding-top: 12px;
}
.detail-right .__bottom {
    display: flex;
    //   justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    color: #848691;
    font-size: 12px;
    text-align: center;
    line-height: normal;

    div {
        margin-right: 10px;
        vertical-align: middle;
    }
    .button {
        margin-left: 10px;
        display: inline-block;
        padding: 4px 12px;
        font-size: 14px;
        font-weight: 500;
        color: #fff;
        background-color: #28a745; /* 蓝色背景 */
        border: none;
        border-radius: 6px; /* 圆角 */
        cursor: pointer;
        transition: background-color 0.2s ease;
    }

    .button:hover {
        background-color: #218838; /* hover 时加深 */
    }

    .button:active {
        background-color: #1e7e34; /* 点击时更深 */
    }

    .button:disabled {
        background-color: #ccc;
        cursor: not-allowed;
    }
}
.tab-content-center {
    text-align: left; /* 文本左对齐 */
    display: flex; /* 如果你用 flex 布局 */
    justify-content: flex-start; /* 子元素靠左 */
}
</style>
